export default function validate(values) {
  let errors = {};

  if (!values.email) {
    errors.email = 'El email es requerido';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Por favor, escribe un email válido';
  }

  return errors;
};